import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/workers/workerfilters/REQUEST';
export const SUCCESS = '@app/workers/workerfilters/SUCCESS';
export const FAILURE = '@app/workers/workerfilters/FAILURE';
export const CLEAR = '@app/workers/workerfilters/CLEAR';

/**
 * Initial state
 */
const loadingItem = {
    id: null,
    name: 'Loading...'
};
const initState = {
    skills: [loadingItem],
    categories: [loadingItem],
    titles: [loadingItem]
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.skills = payload.skills.map((el) => ({
                    ...el,
                    id: `${el.id}`
                }));
                draft.categories = payload.categories.map((el) => ({
                    ...el,
                    id: `${el.id}`
                }));
                draft.titles = payload.titles.map((el) => ({
                    ...el,
                    id: `${el.id}`
                }));
                break;
            case FAILURE:
                draft.errorStatus = payload;
                break;
            case CLEAR:
                draft.skills = [loadingItem];
                draft.categories = [loadingItem];
                draft.titles = [loadingItem];
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            // yield put(creator(CLEAR));
            const response = yield axios.get('/workers/filters', payload);
            yield put(actions.success(response.data));
        } catch (e) {
            console.error(e);
            const error =
                (e.response && e.response.data && e.response.data.message) ||
                'Error: Something went wrong please contact support!';
            yield put(creator(CLEAR));
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
